import { setGlobalTheme } from '@office-start/theming-service';
import { OfficeStartBrandPalette, OfficeStartTheme } from '@office-start/theming-types';

import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { ObservableScope } from '../models/observable-scope.enum';
import { ScopableObservable } from '../utilities/scopable-subject.utility';

let initialized = false;
let osThemeObservable: Observable<OfficeStartTheme>;

// Listens for theme changes and updates the Fluent design tokens
// Lazy loaded as part of office-start wrappers and theming service under a flight.
export function initializeFluentTheme(themeObservable: ScopableObservable<OfficeStartTheme>) {
    if (initialized) {
        return;
    }

    initialized = true;
    osThemeObservable = themeObservable.withScope(ObservableScope.PastAndFuture).pipe(
        distinctUntilChanged((prev, curr) =>
            prev.mode === curr.mode &&
            prev.overridePaletteMapping === curr.overridePaletteMapping &&
            prev.overrideTokenMapping === curr.overrideTokenMapping &&
            prev.themeId === curr.themeId &&
            comparePalettes(prev.lightBrandColors, curr.lightBrandColors) &&
            comparePalettes(prev.darkBrandColors, curr.darkBrandColors)
        )
    );

    osThemeObservable.subscribe( theme => {
        // TODO: should we rely on setGlobalTheme for fabric and legacy themes?
        setGlobalTheme(theme, false, false);
    });
}

export function getOfficeStartThemeObservable(): Observable<OfficeStartTheme> {
    return osThemeObservable;
}

function comparePalettes(palette1: OfficeStartBrandPalette, palette2: OfficeStartBrandPalette) {
    if (palette1 === palette2) {
        return true;
    }

    if (!palette1 || !palette2) {
        return false;
    }

    return palette1.themeDark === palette2.themeDark && palette1.themeDarkAlt === palette2.themeDarkAlt && palette1.themeDarker === palette2.themeDarker && palette1.themeLight === palette2.themeLight && palette1.themeLighter === palette2.themeLighter && palette1.themeLighterAlt === palette2.themeLighterAlt && palette1.themePrimary === palette2.themePrimary && palette1.themeSecondary === palette2.themeSecondary && palette1.themeTertiary === palette2.themeTertiary;
}
